/**************************************************
 * Nombre:       Fechas_RG
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import TituloPeqGrande from "../../../Componentes/TituloPeqGrande";
import Tarjeta_Fechas_RG from "../../../Tarjetas/Tarjeta_Fechas_RG";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Fechas_RG = ({item, cupos}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}}>
                    <TituloPeqGrande peq={'Fechas'} grande={'Disponibles'}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{mt: sCell ? 6 : 8}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        {item?.fechas.map((fecha, index) => {
                            return (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                    <Tarjeta_Fechas_RG fecha={fecha} item={item} cupos={cupos}/>
                                </Grid>
                            )
                        })}

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Fechas_RG